export default __webpack_public_path__ + "static/media/gehandicapten.fe4b16f3.svg";